/**
 * Maps ITF/IOC 3-letter country codes to English display names.
 * The flag images at /img/flags/{code}.svg use the same 3-letter codes.
 *
 * Only tennis-relevant nations are listed; unknown codes fall back to the raw
 * code string so nothing is silently swallowed.
 */
const NATIONALITY_NAMES = {
    AFG: 'Afghanistan',
    ALB: 'Albania',
    ALG: 'Algeria',
    AND: 'Andorra',
    ANG: 'Angola',
    ARG: 'Argentina',
    ARM: 'Armenia',
    ARU: 'Aruba',
    ASA: 'American Samoa',
    AUS: 'Australia',
    AUT: 'Austria',
    AZE: 'Azerbaijan',
    BAH: 'Bahamas',
    BAN: 'Bangladesh',
    BAR: 'Barbados',
    BEL: 'Belgium',
    BEN: 'Benin',
    BER: 'Bermuda',
    BHU: 'Bhutan',
    BOL: 'Bolivia',
    BIH: 'Bosnia & Herzegovina',
    BOT: 'Botswana',
    BRA: 'Brazil',
    BRN: 'Brunei',
    BUL: 'Bulgaria',
    BUR: 'Burkina Faso',
    CAM: 'Cambodia',
    CMR: 'Cameroon',
    CAN: 'Canada',
    CAY: 'Cayman Islands',
    CHI: 'Chile',
    CHN: 'China',
    COL: 'Colombia',
    CRC: 'Costa Rica',
    CRO: 'Croatia',
    CYP: 'Cyprus',
    CZE: 'Czech Republic',
    DEN: 'Denmark',
    DOM: 'Dominican Republic',
    ECU: 'Ecuador',
    EGY: 'Egypt',
    ESA: 'El Salvador',
    EST: 'Estonia',
    ETH: 'Ethiopia',
    FIJ: 'Fiji',
    FIN: 'Finland',
    FRA: 'France',
    GEO: 'Georgia',
    GER: 'Germany',
    GHA: 'Ghana',
    GBR: 'Great Britain',
    GRE: 'Greece',
    GUA: 'Guatemala',
    HAI: 'Haiti',
    HON: 'Honduras',
    HKG: 'Hong Kong',
    HUN: 'Hungary',
    ISL: 'Iceland',
    IND: 'India',
    INA: 'Indonesia',
    IRI: 'Iran',
    IRQ: 'Iraq',
    IRL: 'Ireland',
    ISR: 'Israel',
    ITA: 'Italy',
    JAM: 'Jamaica',
    JPN: 'Japan',
    JOR: 'Jordan',
    KAZ: 'Kazakhstan',
    KEN: 'Kenya',
    KOR: 'Korea',
    KUW: 'Kuwait',
    KGZ: 'Kyrgyzstan',
    LAT: 'Latvia',
    LIB: 'Lebanon',
    LTU: 'Lithuania',
    LUX: 'Luxembourg',
    MAC: 'Macau',
    MAS: 'Malaysia',
    MLT: 'Malta',
    MRI: 'Mauritius',
    MEX: 'Mexico',
    MDA: 'Moldova',
    MON: 'Monaco',
    MGL: 'Mongolia',
    MNE: 'Montenegro',
    MAR: 'Morocco',
    MOZ: 'Mozambique',
    NAM: 'Namibia',
    NEP: 'Nepal',
    NED: 'Netherlands',
    NZL: 'New Zealand',
    NCA: 'Nicaragua',
    NGR: 'Nigeria',
    NOR: 'Norway',
    OMA: 'Oman',
    PAK: 'Pakistan',
    PAN: 'Panama',
    PAR: 'Paraguay',
    PER: 'Peru',
    PHI: 'Philippines',
    POL: 'Poland',
    POR: 'Portugal',
    PUR: 'Puerto Rico',
    QAT: 'Qatar',
    ROM: 'Romania',
    RUS: 'Russia',
    SAU: 'Saudi Arabia',
    SEN: 'Senegal',
    SRB: 'Serbia',
    SVK: 'Slovakia',
    SLO: 'Slovenia',
    RSA: 'South Africa',
    ESP: 'Spain',
    SRI: 'Sri Lanka',
    SWE: 'Sweden',
    SUI: 'Switzerland',
    TPE: 'Chinese Taipei',
    THA: 'Thailand',
    TTO: 'Trinidad & Tobago',
    TUN: 'Tunisia',
    TUR: 'Turkey',
    TKM: 'Turkmenistan',
    UGA: 'Uganda',
    UKR: 'Ukraine',
    UAE: 'United Arab Emirates',
    URU: 'Uruguay',
    USA: 'United States',
    UZB: 'Uzbekistan',
    VEN: 'Venezuela',
    VIE: 'Vietnam',
    ZIM: 'Zimbabwe',
};

/**
 * Returns the English country name for a 3-letter nationality code.
 * Falls back to the raw code if unknown.
 */
export const getNationalityName = (code) => {
    if (!code) {
        return '';
    }
    return NATIONALITY_NAMES[code.toUpperCase()] || code;
};
